import { memo } from 'react';
import { GitBranch } from 'lucide-react';
import type { NodeProps } from '@xyflow/react';
import type { ComposerNodeData } from '../../../types/composer';
import { ComposerNodeCard } from './ComposerNodeCard';

export const ConditionNode = memo((props: NodeProps) => (
  <ComposerNodeCard
    {...props}
    data={props.data as ComposerNodeData}
    typeName="condition"
    glyph={<GitBranch size={14} strokeWidth={2.2} />}
  />
));

ConditionNode.displayName = 'ConditionNode';
